import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { LOGO_URL } from "../data/brand";

export default function Footer() {
  const [cities, setCities] = useState([]);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    api.get("/cities/top").then((r) => setCities(r.data)).catch(() => {});
    api.get("/categories").then((r) => setCategories(r.data)).catch(() => {});
  }, []);

  return (
    <footer className="border-t border-zinc-900 bg-black mt-24" data-testid="main-footer">
      {/* SEO internal linking blocks */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 py-12 space-y-10">
        {/* Cities */}
        {cities.length > 0 && (
          <div data-testid="footer-cities">
            <div className="text-xs uppercase tracking-widest text-[#FFBE00] mb-4">Trova professionisti per città</div>
            <div className="flex flex-wrap gap-2">
              {cities.map((c) => (
                <Link
                  key={c.slug}
                  to={`/professionisti-affitti-brevi/${c.slug}`}
                  className="px-3 py-1 text-xs rounded-full border border-zinc-800 text-zinc-400 hover:border-[#FFBE00] hover:text-[#FFBE00] transition-colors"
                >
                  Affitti brevi {c.name}
                </Link>
              ))}
            </div>
          </div>
        )}

        {/* Categories */}
        {categories.length > 0 && (
          <div data-testid="footer-categories">
            <div className="text-xs uppercase tracking-widest text-[#E619A8] mb-4">Categorie professionali</div>
            <div className="flex flex-wrap gap-2">
              {categories.map((c) => (
                <Link
                  key={c.slug}
                  to={`/categoria/${c.slug}`}
                  className="px-3 py-1 text-xs rounded-full border border-zinc-800 text-zinc-400 hover:border-[#E619A8] hover:text-[#E619A8] transition-colors"
                >
                  {c.name}
                </Link>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Main columns */}
      <div className="border-t border-zinc-900 max-w-7xl mx-auto px-4 md:px-8 py-14 grid grid-cols-2 md:grid-cols-4 gap-10">
        <div className="col-span-2 md:col-span-1">
          <img src={LOGO_URL} alt="HostMarket" className="h-9 w-auto mb-4" />
          <p className="text-sm text-zinc-400 max-w-xs leading-relaxed">La piazza digitale dei professionisti degli affitti brevi. Un prodotto dell'ecosistema <a href="https://vitadahost.it" target="_blank" rel="noreferrer" className="font-bold text-white hover:text-[#FFBE00]">vitadahost.it</a>.</p>
          <a
            href={`${process.env.REACT_APP_BACKEND_URL}/api/rss.xml`}
            target="_blank"
            rel="noreferrer"
            className="mt-5 inline-flex items-center gap-2 px-3.5 py-2 rounded-lg border border-[#FF8800]/40 bg-[#FF8800]/10 hover:bg-[#FF8800]/20 hover:border-[#FF8800] text-[#FF8800] text-xs font-bold uppercase tracking-wider transition-all"
            data-testid="footer-rss"
            title="Feed RSS degli ultimi annunci"
          >
            <i className="fas fa-rss"></i>
            <span>Feed RSS</span>
          </a>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4">Piattaforma</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/annunci" className="hover:text-[#FFBE00]">Annunci</Link></li>
            <li><Link to="/categorie" className="hover:text-[#FFBE00]">Categorie</Link></li>
            <li><Link to="/prezzi" className="hover:text-[#FFBE00]">Prezzi</Link></li>
            <li><Link to="/faq" className="hover:text-[#FFBE00]">FAQ</Link></li>
            <li><Link to="/contatti" className="hover:text-[#FFBE00]">Contatti</Link></li>
            <li><Link to="/rivendica" className="hover:text-[#FFBE00]">Rivendica annuncio</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4">Professionisti</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/registrati" className="hover:text-[#E619A8]">Pubblica annuncio</Link></li>
            <li><Link to="/login" className="hover:text-[#E619A8]">Accedi</Link></li>
            <li><Link to="/dashboard" className="hover:text-[#E619A8]">Dashboard</Link></li>
            <li><Link to="/recupera-password" className="hover:text-[#E619A8]">Password dimenticata</Link></li>
          </ul>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mt-6 mb-3">Legale</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li><Link to="/privacy" className="hover:text-[#FFBE00]">Privacy Policy</Link></li>
            <li><Link to="/cookie" className="hover:text-[#FFBE00]">Cookie Policy</Link></li>
            <li><Link to="/termini" className="hover:text-[#FFBE00]">Termini e Condizioni</Link></li>
          </ul>
        </div>
        <div>
          <div className="text-xs uppercase tracking-widest text-zinc-500 mb-4">Vita da Host</div>
          <ul className="space-y-2 text-sm text-zinc-300">
            <li className="flex items-start gap-2"><i className="fas fa-map-marker-alt text-[#E619A8] mt-1"></i><span>Genova, Italia</span></li>
            <li className="flex items-start gap-2"><i className="fas fa-phone text-[#FFBE00] mt-1"></i><a href="tel:+393333688328" className="hover:text-white">333 368 8328</a></li>
            <li className="flex items-start gap-2"><i className="fas fa-envelope text-[#FFBE00] mt-1"></i><a href="mailto:vitadahost@gmail.com" className="hover:text-white">vitadahost@gmail.com</a></li>
            <li className="flex items-start gap-2"><i className="fas fa-globe text-[#FFBE00] mt-1"></i><a href="https://vitadahost.it" target="_blank" rel="noreferrer" className="hover:text-white">vitadahost.it</a></li>
            <li className="text-xs text-zinc-500 pt-2">P.IVA 02903680995</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-zinc-900 py-6 text-center text-xs text-zinc-600 px-4">
        © {new Date().getFullYear()} HostMarket · Prodotto dell'ecosistema <a href="https://vitadahost.it" target="_blank" rel="noreferrer" className="text-zinc-400 hover:text-[#FFBE00]">Vita da Host</a> · P.IVA 02903680995 · Genova · <Link to="/privacy" className="hover:text-[#FFBE00]">Privacy</Link> · <Link to="/cookie" className="hover:text-[#FFBE00]">Cookie</Link> · <Link to="/termini" className="hover:text-[#FFBE00]">Termini</Link>
      </div>
    </footer>
  );
}
